/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { rem } from "@src/theme"
import Download from "@components/assets/svg/download.svg"

const HubspotDownloadButton = ({
  label = "Download",
  openHubspotModal,
  setHubspotTag,
  hubspotTag,
}) => (
  <button
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "inherit",
      cursor: "pointer",
    }}
    onClick={() => {
      openHubspotModal()
      setHubspotTag(hubspotTag)
    }}
  >
    <span
      sx={{
        display: "block",
        variant: "typography.link",
        textDecoration: "underline",
        color: "inherit",
        "&.active": {
          color: "primary",
        },
      }}
    >
      {label}
    </span>

    <div
      sx={{
        width: rem(13),
        transform: "translate(8px, -2px)",
      }}
    >
      <Download width="100%" />
    </div>
  </button>
)

HubspotDownloadButton.propTypes = {
  link: PropTypes.string,
  label: PropTypes.string,
}

export default connect(null, dispatch => ({
  openHubspotModal: () => dispatch.hubspotModal.toggleModal(true),
  setHubspotTag: tag => dispatch.hubspotModal.setHubspotTag(tag),
}))(HubspotDownloadButton)
